"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PetraWalletAdapter = void 0;
const baseAptosWalletAdapter_1 = require("./baseAptosWalletAdapter");
const aptosWalletAdapter_1 = require("./aptosWalletAdapter");
const utils_1 = require("../../../../utils/utils");
const protocol_1 = require("../../../../protocol");
class PetraWalletAdapter extends baseAptosWalletAdapter_1.BaseAptosWalletAdapter {
    get readyState() {
        return this._readyState;
    }
    getPerta() {
        var _a;
        if (this._provider) {
            return this._provider;
        }
        if (!window.petra) {
            return undefined;
        }
        let perta = window.petra;
        if (perta && (perta.isOKExWallet || perta.isOkxWallet || ((_a = window.okxwallet) === null || _a === void 0 ? void 0 : _a.aptos) === perta)) {
            return undefined;
        }
        this._provider = perta;
        return perta;
    }
    constructor() {
        super();
        this.name = 'Petra';
        this.icon = 'https://raw.githubusercontent.com/hippospace/aptos-wallet-adapter/main/logos/petra.png';
        this.url = '';
        this._version = "unknown";
        this._readyState = typeof window === 'undefined' || typeof document === 'undefined'
            ? aptosWalletAdapter_1.WalletReadyState.Unsupported
            : aptosWalletAdapter_1.WalletReadyState.NotDetected;
        this._network = undefined;
        this._connecting = false;
        this._wallet = null;
        if (typeof window !== 'undefined' && this._readyState !== aptosWalletAdapter_1.WalletReadyState.Unsupported) {
            (0, utils_1.scopePollingDetectionStrategy)(() => {
                if (this.getPerta()) {
                    this._readyState = aptosWalletAdapter_1.WalletReadyState.Installed;
                    // this.emit('readyStateChange', this._readyState);
                    return true;
                }
                return false;
            });
        }
    }
    get publicAccount() {
        var _a, _b, _c;
        return {
            publicKey: ((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.publicKey) || null,
            address: ((_b = this._wallet) === null || _b === void 0 ? void 0 : _b.address) || null,
            authKey: ((_c = this._wallet) === null || _c === void 0 ? void 0 : _c.authKey) || null
        };
    }
    get connecting() {
        return this._connecting;
    }
    get version() {
        return this._version;
    }
    get network() {
        return {
            name: this._network,
        };
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!(this._readyState === aptosWalletAdapter_1.WalletReadyState.Loadable ||
                    this._readyState === aptosWalletAdapter_1.WalletReadyState.Installed)) {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED);
                }
                // if (this.connecting) return;
                if (this.connected) {
                    yield this.initNetWork();
                    return;
                }
                this._connecting = true;
                const provider = this.getPerta();
                const response = yield (provider === null || provider === void 0 ? void 0 : provider.connect());
                this._wallet = {
                    address: response === null || response === void 0 ? void 0 : response.address,
                    publicKey: response === null || response === void 0 ? void 0 : response.publicKey,
                    isConnected: true
                };
                yield this.initNetWork();
                // this.emit('connect', this._wallet?.address || '');
            }
            catch (error) {
                throw error;
            }
            finally {
                this._connecting = false;
            }
        });
    }
    initNetWork() {
        return __awaiter(this, void 0, void 0, function* () {
            const provider = this.getPerta();
            const name = yield (provider === null || provider === void 0 ? void 0 : provider.network());
            const chainId = null;
            const api = null;
            this._network = name;
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this._wallet;
            const provider = this.getPerta();
            if (wallet) {
                this._wallet = null;
                try {
                    yield (provider === null || provider === void 0 ? void 0 : provider.disconnect());
                }
                catch (error) {
                }
            }
        });
    }
    signAndSubmitTransaction(transaction, options) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wallet = this._wallet;
                const provider = this.getPerta();
                if (!wallet || !provider)
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED);
                const response = yield provider.signAndSubmitTransaction(transaction, options);
                if (response.code) {
                    throw new Error(response.message);
                }
                return response;
            }
            catch (error) {
                throw error;
            }
        });
    }
    signTransaction(transaction, options) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wallet = this._wallet;
                const provider = this.getPerta();
                if (!wallet || !provider)
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED);
                const response = yield (provider === null || provider === void 0 ? void 0 : provider.signTransaction(transaction));
                if (response.code) {
                    throw new Error(response.message);
                }
                return response;
            }
            catch (error) {
                throw error;
            }
        });
    }
    signMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wallet = this._wallet;
                const provider = this.getPerta();
                if (!wallet || !provider)
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.WALLET_NOT_SUPPORTED);
                const response = yield (provider === null || provider === void 0 ? void 0 : provider.signMessage(message));
                if (response) {
                    return response;
                }
                else {
                    throw new Error('Sign Message failed');
                }
            }
            catch (error) {
                throw error;
            }
        });
    }
    onAccountChange(listener) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wallet = this._wallet;
                const provider = this.getPerta();
                const handleAccountChange = (newAccount) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d, _e, _f;
                    if (newAccount === null || newAccount === void 0 ? void 0 : newAccount.publicKey) {
                        this._wallet = Object.assign(Object.assign({}, this._wallet), { publicKey: newAccount.publicKey || ((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.publicKey), authKey: newAccount.authKey || ((_b = this._wallet) === null || _b === void 0 ? void 0 : _b.authKey), address: newAccount.address || ((_c = this._wallet) === null || _c === void 0 ? void 0 : _c.address) });
                    }
                    else {
                        const response = yield (provider === null || provider === void 0 ? void 0 : provider.connect());
                        this._wallet = Object.assign(Object.assign({}, this._wallet), { authKey: (response === null || response === void 0 ? void 0 : response.authKey) || ((_d = this._wallet) === null || _d === void 0 ? void 0 : _d.authKey), address: (response === null || response === void 0 ? void 0 : response.address) || ((_e = this._wallet) === null || _e === void 0 ? void 0 : _e.address), publicKey: (response === null || response === void 0 ? void 0 : response.publicKey) || ((_f = this._wallet) === null || _f === void 0 ? void 0 : _f.publicKey) });
                    }
                    // this.emit('accountChange', newAccount.publicKey);
                    listener === null || listener === void 0 ? void 0 : listener(this._wallet);
                });
                provider === null || provider === void 0 ? void 0 : provider.onAccountChange(handleAccountChange);
            }
            catch (error) {
                throw error;
            }
        });
    }
    onNetworkChange() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const wallet = this._wallet;
                const provider = this.getPerta();
                const handleNetworkChange = (newNetwork) => __awaiter(this, void 0, void 0, function* () {
                    if (newNetwork) {
                        this._network = newNetwork.networkName;
                    }
                });
                // provider?.onNetworkChange(handleNetworkChange);
            }
            catch (error) {
                throw error;
            }
        });
    }
}
exports.PetraWalletAdapter = PetraWalletAdapter;
